<template>
  <div class="other">
    <div class="container">
      <div class="titleNav">
        <router-link to="/courier/cityExpress">我要下单</router-link> /
        <router-link to="/courier/other">其他服务</router-link>
      </div>
      <div class="content">
        <div class="info">
          <div class="left">
            <label for="">
              <span>代办时间:</span>
              <el-date-picker
                type="dates"
                 @change="changeTime"
                v-model="value1"
                placeholder="选择一个或多个日期">
              </el-date-picker>
            </label>
            <label for="">
              <span>联系人姓名:</span>
              <input type="text" placeholder="请输入联系人姓名" v-model="info.name">
            </label>
            <label for="">
              <span>联系人电话:</span>
              <input type="text" placeholder="请输入联系人电话" v-model="info.mobile">
            </label>
            <label for="">
              <span>服务内容:</span>
              <textarea placeholder="请输入服务内容" v-model="info.serviceContent"></textarea>
            </label>
            <label for="">
              <span>备注信息:</span>
              <textarea placeholder="请输入备注信息" v-model="info.description"></textarea>
            </label>
            <p class="notice">注：不输入表示无要求</p>
          </div>
          <div class="right">
            <label for="">
              <span>收货地址:</span>
              <input id="suggestId" class="input" type="text" placeholder="小区名、大厦名、街道门牌号" @keyup.enter="getAddress" @blur="getAddress" v-model="info.sendAddress">
            </label>
            <label for="">
              <span>详细地址:</span>
              <input type="text" placeholder="楼层、门牌号" v-model="info.sendAddressDetail">
            </label>
            <!--地图-->
            <div id="allmap"  class="allmap"></div>
          </div>
        </div>

        <button class="next" @click="next">下一步</button>
      </div>
    </div>
  </div>
</template>

<script>
import DateTime from '../../../components/Time'
import {init, tip} from '../../../utils/map'
import {mobiles} from '../../../utils/phone'
import {reqOrderOther} from '../../../api'
import {formatDate} from '../../../utils/date'
export default {
  data() {
    return {
      value1:'',
      info:{
        getGoodsDate: '', // 代办时间
        name: '', // 联系人姓名
        mobile: '', // 联系人手机
        serviceContent: '', // 服务内容
        description: '', // 备注
        sendAddress: '', // 地址
        sendAddressDetail: '', // 详细地址
        origin:1
      },
      type: 'datetime' // 时间类型
    }
  },
  mounted () {
    this.$nextTick(() => {
      let input = document.getElementsByClassName('input')[0]
      // let am = document.getElementsByClassName('allmap')[0]
      init('深圳', 'allmap')
      tip('suggestId', input, 'allmap', '深圳')
      // for (let i = 0; i < am.length; i++) {
      //   init('深圳', am[i].id)
      //   for (let j = 0; j < input.length; j++) {
      //     tip(input[j].id, input[j], am[i].id, '深圳')
      //   }
      // }
    })
  },
  methods: {
     // 获取时间
    changeTime(val) {
       let arrDate=[]
        val.forEach(item=>{
          arrDate.push(formatDate(new Date(item), 'yyyy-MM-dd ')+'00:00:00')
        })
      this.info.getGoodsDate = arrDate.join(',')

    },
    // 获取时间
    times (time) {
      this.info.getGoodsDate = time
    },
    // 根据地址名称更换地图
    getAddress (e) {
      let inputId = e.target.id
      let type = e.target.parentNode.nextElementSibling.nextElementSibling.id
      // init(e.target.value, type)
      this.info.sendAddress = e.target.value
      init(e.target.value, type, inputId, e.target)
    },
    next () {

      const {getGoodsDate, name, mobile, serviceContent, sendAddress, sendAddressDetail} = this.info
      console.log(getGoodsDate)
      if(!getGoodsDate) {
        this.$message({
          message: '代办时间不能为空',
          type:'error'
        })
      } else if(!name) {
        this.$message({
          message: '联系人姓名不能为空',
          type:'error'
        })
      } else if(!mobile) {
        this.$message({
          message: '联系人电话不能为空',
          type:'error'
        })
      } else if(!mobiles(mobile)) {
        this.$message({
          message: '联系人电话不正确',
          type:'error'
        })
      } else if(!serviceContent) {
        this.$message({
          message: '服务内容不能为空',
          type:'error'
        })
      } else if(!sendAddress) {
        this.$message({
          message: '收货地址不能为空',
          type:'error'
        })
      }else{
        this.$store.dispatch('getOtherInfo', this.info)

        reqOrderOther(this.info).then(res => {
          if(res.code === 200) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$router.push({name: 'OtherOrder'})
          }
        })

      }
    }
  },
  components: {
    DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
.other{
  margin-bottom: 77px;
  .titleNav{
    margin:30px 0 41px;
  }
  .content{
    padding: 40px 30px;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    .info{
      overflow: hidden;
      .left{
        float: left;
        padding-right: 140px;
        border-right: 1px solid #e1e1e1;
        .notice{
          margin-top:11px;
          color:#999;
          text-indent: 102px;
        }
      }
      .right{
        float: left;
        margin-left: 40px;
      }
    }
    .next{
      display: block;
      width: 332px;
      height: 48px;
      border:none;
      margin:48px auto 0;
      background: #61aee6;
      color: #fff;
      border-radius: 24px;
      cursor: pointer;
    }
    label{
      display: flex;
      margin-bottom: 20px;
      &:last-of-type{
        margin-bottom: 0;
      }
      span{
        display: block;
        width: 80px;
        text-align: right;
        line-height: 40px;
        margin-right:12px;
      }
      input{
        width: 340px;
        height: 40px;
        text-indent: 13px;
        box-sizing: border-box;
        border:1px solid #e1e1e1;
        border-radius: 4px;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
      textarea{
        width: 340px;
        height: 100px;
        resize: none;
        box-sizing: border-box;
        text-indent: 13px;
        border:1px solid #e1e1e1;
        border-radius: 4px;
        &::-webkit-input-placeholder{
          color:#c0c4cc;
        }
      }
    }

  }
  .allmap{
    width: 511px;
    height: 260px;
    margin-top:23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Other/Other.vue